import React from 'react';
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';
import { AffectedRatePlanModel, RatePlanActionResultType, RatePlanRequest } from '../../api/pricing/pricing.types';
import { withTranslation, WithTranslation } from 'react-i18next';
import { formatDate } from '../../helpers/date.helper';

interface AffectedRatePlansModalProps extends WithTranslation {
  isOpen: boolean;
  onConfirm: (request: RatePlanRequest) => void;
  onCancel: () => void;
  ratePlans: AffectedRatePlanModel[];
  request: RatePlanRequest;
}

class AffectedRatePlansModal extends React.PureComponent<AffectedRatePlansModalProps> {

  render() {
    const { t } = this.props;

    return (
      <Modal isOpen={this.props.isOpen} toggle={this.props.onCancel} autoFocus={false}>
        <ModalHeader toggle={this.props.onCancel}>{t('modal_text.rate_plan.affected_title')}</ModalHeader>
        <ModalBody>
          <div>{t('modal_text.rate_plan.affected_text')}</div>
          {this.props.ratePlans.findIndex((r) => r.actionResultType === RatePlanActionResultType.ALTERED) !== -1 ? (
            <>
              <div className="font-weight-bold mt-1">{t('modal_text.rate_plan.affected.updated')}</div>
              <div className="p-2">
                {this.props.ratePlans.map((rp) => {
                    if (rp.actionResultType === RatePlanActionResultType.ALTERED) {
                      return (
                        <div
                          key={`affected-${rp.id}`}>{`${rp.name} (${formatDate(rp.validFrom)} - ${formatDate(rp.validTo)})`}</div>
                      );
                    }
                  }
                )}
              </div>
            </>
          ) : ''}
          {this.props.ratePlans.findIndex((r) => r.actionResultType === RatePlanActionResultType.DELETED) !== -1 ? (
            <>
              <div className="font-weight-bold mt-1">{t('modal_text.rate_plan.affected.deleted')}</div>
              <div className="p-2">
                {this.props.ratePlans.map((rp) => {
                    if (rp.actionResultType === RatePlanActionResultType.DELETED) {
                      return (
                        <div key={`affected-${rp.id}`}>{`${rp.name} (${formatDate(rp.validFrom)} - ${formatDate(rp.validTo)})`}</div>
                      );
                    }
                  }
                )}
              </div>
            </>
          ) : ''}
        </ModalBody>
        <ModalFooter>
          <Button className="mr-1 btn btn-outline-secondary" color="secondary" onClick={this.props.onCancel}>
            {t('b.cancel_Generic cancel button translation').toUpperCase()}</Button>
          <Button color="primary" onClick={() => this.props.onConfirm(this.props.request)}>{t('b.confirm').toUpperCase()}</Button>
        </ModalFooter>
      </Modal>
    );
  }
}

export default withTranslation()(AffectedRatePlansModal);
